export default {
  name: "HR",
  data() {
    return {
      statut: "consulting",
      selected: "",
      employee: {},
      employees: []
    };
  },
  methods: {
    get_emps() {
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/employees/get_employees", {}, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(async response => {
        const data = response.data;
        this.employees = data.map(el => {
          return {
            value: el.id_emp,
            text: el.id_emp_ci + " - " + el.Nom_complet
          };
        });
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
        }
      });
    },
    getEmpData() {
      const axios = require("axios");
      this.statut = "consulting";
      axios.post(this.$store.state.api_url + "/employees/get_employee_data", {
        id_emp: this.selected
      }, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(async response => {
        var data = response.data;
        if (data.id_emp == null) data.id_emp = this.selected;
        this.employee = data;
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
        }
      });
    },
    update_button(statut) {
      switch (statut) {
        case "consulting":
          {
            this.statut = "updating";
            break;
          }
        case "updating":
          {
            this.statut = "consulting";
            if (this.employee.Nom_complet && this.employee.Nom_complet.trim() != "" && this.employee.id_emp_ci && this.id_emp_ci != 0) {
              const axios = require("axios");
              axios.post(this.$store.state.api_url + "/employees/update_employee", this.employee, {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token
                }
              }).then(response => {
                console.log(response);
                this.$bvToast.toast("Modifié avec succée", {
                  title: `Succée`,
                  variant: "success",
                  solid: true
                });
                this.get_emps();
              }).catch(err => {
                if (err.response.status === 401) {
                  console.log("uNauthorized request");
                  console.log(err);
                  this.error();
                } else {
                  console.log("error : " + err);
                  this.$bvToast.toast("Erreur", {
                    variant: "danger",
                    solid: true
                  });
                }
              });
            } else {
              this.$bvToast.toast("Nom ou/et identifiant  Invalide(s)", {
                variant: "danger",
                solid: true
              });
            }
            break;
          }
      }
    },
    delete_button() {
      this.$bvModal.msgBoxConfirm("Merci de confirmer la suppression de l'employee", {
        title: "Confirmation",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "OUI",
        cancelTitle: "No",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          const axios = require("axios");
          axios.post(this.$store.state.api_url + "/employees/delete_employee", {
            id_emp: this.selected
          }, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token
            }
          }).then(response => {
            console.log(response);
            this.$bvToast.toast("Supprimé avec succée", {
              title: `Succée`,
              variant: "success",
              solid: true
            });
            this.selected = "";
            this.employee = new Object();
            this.get_emps();
          }).catch(err => {
            if (err.response.status === 401) {
              console.log("uNauthorized request");
              console.log(err);
              this.error();
            } else {
              console.log("error : " + err);
              this.$bvToast.toast("Erreur", {
                variant: "danger",
                solid: true
              });
            }
          });
        }
      }).catch(err => {
        // An error occurred
        console.log(err);
      });
    },
    update_password() {
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/employees/update_password", this.employee, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        console.log(response);
        this.$bvToast.toast("Mot de Passe Changé ", {
          title: `Succée`,
          variant: "success",
          solid: true
        });
        this.$root.$emit("bv::hide::modal", "changePassword_Modal");
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
          this.$bvToast.toast("Erreur", {
            variant: "danger",
            solid: true
          });
        }
      });
    },
    update_poste() {
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/employees/change_poste", this.employee, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        console.log(response);
        this.$bvToast.toast("Poste Changé", {
          title: `Succée`,
          variant: "success",
          solid: true
        });
        this.getEmpData();
        this.$root.$emit("bv::hide::modal", "changePoste_modal");
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
          this.$bvToast.toast("Erreur", {
            variant: "danger",
            solid: true
          });
        }
      });
    },
    add_button(statut) {
      switch (statut) {
        case "consulting":
          {
            this.statut = "adding";
            this.selected = "";
            this.employee = new Object();
            this.employee.id_emp_ci = this.employees.length + 1;
            break;
          }
        case "adding":
          {
            this.statut = "consulting";
            if (this.employee.Nom_complet && this.employee.Nom_complet.trim() != "" && this.employee.id_emp_ci && this.id_emp_ci != 0) {
              const axios = require("axios");
              axios.post(this.$store.state.api_url + "/employees/add_employee", this.employee, {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token
                }
              }).then(response => {
                console.log(response);
                this.$bvToast.toast("Ajouté avec succée", {
                  title: `Succée`,
                  variant: "success",
                  solid: true
                });
                this.get_emps();
              }).catch(err => {
                if (err.response.status === 401) {
                  console.log("uNauthorized request");
                  console.log(err);
                  this.error();
                } else {
                  console.log("error : " + err);
                  this.$bvToast.toast("Erreur", {
                    variant: "danger",
                    solid: true
                  });
                }
              });
            } else {
              this.$bvToast.toast("Nom ou/et identifiant  Invalide(s)", {
                variant: "danger",
                solid: true
              });
            }
            break;
          }
      }
    },
    error() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    }
  },
  mounted() {
    this.get_emps();
  }
};